import { useState, useEffect, useCallback } from "react";
import api from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { DollarSign, Building2, FileText, TrendingDown } from "lucide-react";

export default function PurchaseReportsPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    Promise.all([
      api.get("/purchase-orders?limit=500"),
      api.get("/expenses?limit=500"),
      api.get("/suppliers?limit=500"),
    ]).then(([po, exp, sup]) => {
      const pos = po.data.purchase_orders || [];
      const expenses = exp.data.expenses || [];
      const totalPO = pos.reduce((s, p) => s + (parseFloat(p.total) || 0), 0);
      const totalExp = expenses.reduce((s, e) => s + (parseFloat(e.amount || e.total) || 0), 0);
      setData({ totalPO, totalExp, poCount: pos.length, expCount: expenses.length, supplierCount: (sup.data.suppliers || []).length,
        topSuppliers: Object.entries(pos.reduce((m, p) => { m[p.supplier_name || "Unknown"] = (m[p.supplier_name || "Unknown"] || 0) + (parseFloat(p.total) || 0); return m; }, {})).sort((a, b) => b[1] - a[1]).slice(0, 5),
      });
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="animate-pulse h-60 bg-gray-100 rounded-sm" />;
  if (!data) return null;
  const fmt = v => `R${(v || 0).toLocaleString("en-ZA", { minimumFractionDigits: 2 })}`;
  return (
    <div data-testid="purchase-reports-page">
      <div className="mb-6"><h1 className="font-heading font-bold text-2xl text-[#1F2937]">Purchase Reports</h1></div>
      <div className="grid grid-cols-4 gap-4 mb-6">
        {[["Total POs", fmt(data.totalPO), FileText, "text-blue-600 bg-blue-50"], ["Total Expenses", fmt(data.totalExp), TrendingDown, "text-red-600 bg-red-50"], ["PO Count", data.poCount, DollarSign, "text-green-600 bg-green-50"], ["Suppliers", data.supplierCount, Building2, "text-purple-600 bg-purple-50"]].map(([t, v, I, c]) => (
          <Card key={t} className="border rounded-sm"><CardContent className="p-4"><div className={`w-8 h-8 rounded-lg flex items-center justify-center mb-2 ${c}`}><I className="w-4 h-4" /></div><div className="text-xs text-gray-500 uppercase font-semibold">{t}</div><div className="text-xl font-bold text-[#1F2937] mt-1">{v}</div></CardContent></Card>
        ))}
      </div>
      <Card className="border rounded-sm"><CardContent className="p-4"><h3 className="text-sm font-semibold text-gray-700 mb-3">Top Suppliers by PO Value</h3>
        <div className="space-y-2">{(data.topSuppliers || []).map(([name, amt], i) => (
          <div key={i} className="flex items-center justify-between text-sm"><span className="text-gray-700">{name}</span><span className="font-semibold">{fmt(amt)}</span></div>
        ))}</div></CardContent></Card>
    </div>
  );
}
